module.exports = __webpack_public_path__ + "img/success.d1dfb0a2.svg";